import React, {Component} from 'react';
import Picture from '../Shared/Picture';

class HairTip extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="caringForYourHair-box">
                <a target={this.props.step.ButtonTarget.Value} href={this.props.step.ButtonUrl.Value}>
                    <Picture
                        src={this.props.step.Image.Value}
                        alt={this.props.step.ImageAlt.Value}
                        mobileWidth={245}
                        mobileHeight={171}
                    />
                </a>
                <div className="text">
                    <a target={this.props.step.ButtonTarget.Value} href={this.props.step.ButtonUrl.Value}><h2>{this.props.step.Title.Value}</h2></a>
                    <span>{this.props.step.Description.Value}</span>
                    <a target={this.props.step.ButtonTarget.Value} className="button inverse" href={this.props.step.ButtonUrl.Value}>{this.props.step.ButtonText.Value}</a>
                </div>
            </div>
        )
    }
 }

export default HairTip;
